export default __webpack_public_path__ + "static/media/apple_app_store.d7fa5510.svg";